import { render, staticRenderFns } from "./TicketPage.vue?vue&type=template&id=55e09c10&scoped=true"
import script from "./TicketPage.vue?vue&type=script&lang=js"
export * from "./TicketPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e09c10",
  null
  
)

export default component.exports